/* global axios */

import ApiClient from './ApiClient';

class Sectors extends ApiClient {
  constructor() {
    super('sectors', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url, { params: { for_assignment: true } });
  }

  getTeamsBySector(sectorId) {
    const params = { for_assignment: true };
    if (sectorId) params.sector_id = sectorId;
    return axios.get(this.url.replace('sectors', 'teams'), { params });
  }
}

export default new Sectors();
